import {Component, Prop, Mixins, Watch} from 'vue-property-decorator';
import IconsMixin from '@/mixins/IconsMixin';
import { ServiceType, Service, ServiceTypeId } from './ProductsAndServicesModels';
import {  CrossSale, CrossSaleCatalogItem } from './CrossSaleModels';
import Modal from "@/components/Modal.vue";
import Services from '@/views/products-and-services/ServicesView.vue';
import ColorMixin from '@/mixins/ColorMixin';
import CartNotifications from '@/views/products-and-services/notifications/CartNotifications.vue';

@Component({
    components: {
        CartNotifications,
        Modal,
        Services,
    },
})
export default class ServiceTypesView extends Mixins(IconsMixin, ColorMixin) {
    @Prop({ type: Array, required: false })
    private serviceTypes!: ServiceType[];
    @Prop({ type: Array, required: false })
    private crossSales!: CrossSale[];
    @Prop({ type: Array, required: false })
    private serviceTypeIdsWithError!: string[];

    private selectedServiceType = "";

    @Watch("serviceTypeIdsWithError",{ deep: true })
    hasError() {
        if (this.serviceTypeIdsWithError.length > 0) {
            this.selectedServiceType = this.serviceTypeIdsWithError[this.serviceTypeIdsWithError.length - 1];
        }
    }

    private resolveLearnMore(link: string) {
        window.open(link, "_blank");
    }

    private crossSaleItemClick(content: any) {
        if (content.productId && !this.$store.getters.cartHasServiceType(content.serviceTypeId)) {
            this.storeCrossSaleCatalogItem(content);
        }
        this.selectedServiceType = content.serviceTypeId;
        if (content.productId && this.selectedServiceType === content.serviceTypeId) {
            const selectProduct = `[productid='${content.productId}']`;
            setTimeout(() => {
                if (document.querySelector(selectProduct)) {
                    // @ts-ignore
                    document.querySelector(selectProduct).scrollIntoView({ behavior: "smooth", block: "center" });
                } else {
                    this.$store.commit("setProductIdForCrossSaleCatalogItem", content.productId);
                    this.scrollToService();
                }
            }, 250);
        } else if (this.selectedServiceType === content.serviceTypeId) {
            this.scrollToService();
        }
    }

    private scrollToService() {
        if (
            document.getElementsByClassName("service-type-group__service-type-open") &&
            document.getElementsByClassName("service-type-group__service-type-open")[0]
        ) {
            document.getElementsByClassName("service-type-group__service-type-open")[0].scrollIntoView({
                behavior: "smooth",
                block: "center",
            });
        }
    }

    private crossSaleItemForModal: string = "";

    get isCurrentPageRootLevel() {
        return this.$route.meta && this.$route.meta.isHome;
    }

    get isCrossSaleItemInState() {
        // second part of if - stops the service pop-up when deleting the service from cart after you have clicked on a cross sale
        if (
            this.$store.state.storedCrossSaleCatalogItem &&
            !this.$store.getters.cartHasServiceType(this.$store.state.storedCrossSaleCatalogItem.serviceTypeId)
        ) {
            this.crossSaleItemForModal = this.$store.state.storedCrossSaleCatalogItem.name;
            return this.crossSaleItemForModal;
        }
    }

    get crossSaleModalBodyText(): string {
        return `To know the available options for ${this.crossSaleItemForModal}, please select a service it depends on.`;
    }

    private isServiceTypeComplete(serviceTypeId: string): boolean {
        const selectedService: Service =
            this.$store.state.shoppingCartData.selectedOptions &&
            this.$store.state.shoppingCartData.selectedOptions.services.find((service: Service) => service.serviceTypeId === serviceTypeId);
        if (this.selectedServiceType !== serviceTypeId && selectedService) {
            return true;
        }
        return false;
    }
    private storeCrossSaleCatalogItem(item: CrossSaleCatalogItem) {
        this.$store.commit("storeCrossSaleCatalogItem", item);
    }

    private closeCrossSaleModal() {
        this.$store.commit("clearStoredCrossSaleCatalogItem");
    }
    private editClicked(value: string) {
        this.selectedServiceType = value;
    }

    gotoService(serviceTypeId: ServiceTypeId) {
        this.selectedServiceType = serviceTypeId;
        this.$nextTick(() => {
            this.scrollToService();
        });
    }
}
